export class ChangePhoneNumberRequest {
    newPhone: string = '';
  }